import React from "react";
import PublicRoute from "./routes/route";

const App = () => {
  return <PublicRoute />;
};

export default App;
